import { createInertiaApp } from '@inertiajs/react';
import dayjs from 'dayjs';
import 'dayjs/locale/nl';
import isBetween from 'dayjs/plugin/isBetween';
import isoWeek from 'dayjs/plugin/isoWeek';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import { createRoot } from 'react-dom/client';
import { DashboardLayout } from './layouts';

import './../../css/platform/main.css';

dayjs.locale('nl');
dayjs.extend(isBetween);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(localizedFormat);
dayjs.extend(isoWeek);

createInertiaApp({
    resolve: name => {
        const pages = import.meta.glob('./views/**/*.jsx', { eager: true });
        let page = pages[`./views/${name}.jsx`];
        page.default.layout =
            page.default.layout ||
            (page => <DashboardLayout>{page}</DashboardLayout>);

        return page;
    },
    setup({ el, App, props }) {
        createRoot(el).render(<App {...props} />);
    },
});
